module.exports = __webpack_public_path__ + "img/login-bg1.63aebf6a.png";